@if (loadingUser()) {
    <div class="page-loading-overlay opaque flex-column">
        <mat-spinner></mat-spinner>
        <h1>Loading your account details...</h1>
    </div>
} @else {
    @if (loadingRouteConfig()) {
        <div class="page-loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    }
    <router-outlet />
}
